import type {
    AddCommerceEnrollmentProductRequest,
    AddCommerceEnrollmentProductResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";

export const addCommerceEnrollmentProductOperation: CommerceOperation<
    AddCommerceEnrollmentProductRequest,
    AddCommerceEnrollmentProductResponse
> = Object.freeze({
    name: "commerce.enrollment.products.add",
});
